<template>
    <div class="advantage">
        <div class="advantage-content">
            <h2>软件开发优势</h2>
            <ul>
                <li v-for="item in advantageInfo" :key="item.id">
                    <div >
                        <div class='icon'>
                            <img class="imgfont" :src="$imgUrl+item.icon"></img>
                        </div>
                        <h4>{{item.title}}</h4>
                        <span>{{item.account}}</span>
                    </div>
                </li>
            </ul>
            <span></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Advantage',
    props:{
        advantageInfo: Array
    },
    data () {
        return {
        }
    },
    methods: {
    },
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .advantage
        width: 100%
        background: #000
        overflow: hidden
        .advantage-content
            padding: 10% 6% 0
            text-align: center
            background: #fff
            h2
                position: relative
                display: inline-block
                margin: 0 auto
                color: #333
                font-size: 0.4rem
                font-weight: 1000
                margin-bottom: 40px
                letter-spacing: 1px
                &:after
                    position: absolute
                    display: block
                    content: ''
                    bottom: 0
                    right: -0.14rem
                    width: 0.34rem
                    height: 0.08rem
                    background: $yellow
                    border-radius: 0.05em
                    opacity: 0.8
            ul 
                width: 100%
                li
                    position: relative
                    box-sizing: border-box
                    width: 48%
                    display: inline-block
                    background: #f6f6f6
                    margin-bottom: 4%
                    padding: 6% 12%
                    overflow: hidden
                    .icon
                        padding: 25% 0
                        .imgfont
                            width: 50%
                            font-size: 0.5rem
                            border-radius: 2rem
                    h4
                        font-weight: 1000
                        color: #333
                        font-size: 0.28rem
                        line-height: 1.6em
                        margin-top: 0.42em
                        letter-spacing: 1px
                        font-family: MicrosoftYaHei-Bold
                    span
                        display: block
                        height: 3.6em
                        overflow: hidden
                        font-size: 0.20rem
                        line-height: 1.2em
                        color: #666
                li:nth-of-type(2n+1)
                    margin-right: 4%
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeAdvantage.vue